angular.module('IndicatorType').factory('IndicatorTypeService', function ($http, $httpParamSerializerJQLike) {
  'use strict';

  var rootUri = '';
  var communeID = jQuery('#commune-id').data('commune-id');
  var ajaxTargetPid = 0;
  return {
    writeIndicatorType: function (indicatorType, deletedLists, deletedIndicators) {
      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[indicatorType]': indicatorType,
          'arguments[deletedLists]': deletedLists,
          'arguments[deletedIndicators]': deletedIndicators
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'writeIndicatorType'
          }
        });
    },
    deleteIndicatorType: function (indicatorType) {
      if(!indicatorType) return;
      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[indicatorType]': indicatorType
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'deleteIndicatorType'
          }
        });
    },
    getIndicatorCategories: function () {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorCategories',
            'arguments[commune]': communeID,
            'arguments[all]': true
          }
        }).then(function (response) {
          return response.data;
        });
    },
    getIndicatorKeys: function () {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'getIndicatorKeys',
            'arguments[commune]': communeID
          }
        }).then(function (response) {
          return response.data;
        });
    }
  }
});
